import { render, staticRenderFns } from "./LandingNavbar.vue?vue&type=template&id=0d2d39b5&scoped=true"
import script from "./LandingNavbar.vue?vue&type=script&lang=js"
export * from "./LandingNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d39b5",
  null
  
)

export default component.exports